<ng-container [formGroup]="form">
  <div class="input-group" [class.is-invalid]="sent && hasError('required')">
    <input
      type="text"
      class="form-control data-hj-whitelist"
      autocomplete="off"
      *ngIf="activeLocale === activeOrg.locale.split('-')[0]"
      [name]="name"
      [id]="name"
      [formControlName]="name"
      [class.is-invalid]="sent && hasError('required')"
    />

    <ng-container *ngIf="l10nCtrl" formGroupName="l10n">
      <ng-container *ngFor="let l of l10n">
        <input
          *ngIf="l === activeLocale"
          type="text"
          class="form-control data-hj-whitelist"
          autocomplete="off"
          [name]="name + '_' + l"
          [id]="name + '_' + l"
          [formControlName]="name + '_' + l"
        />
      </ng-container>
    </ng-container>

    <div
      class="input-group-append no-caret"
      ngbDropdown
      container="body"
      placement="bottom-right"
      *ngIf="locales"
    >
      <button
        class="btn btn-outline-secondary"
        type="button"
        ngbTooltip="{{
          'translatable-input.translations.dropdown.tooltip' | translate
        }}"
        ngbDropdownToggle
      >
        <i
          class="fe fe-flag"
          *ngIf="activeLocale === activeOrg.locale.split('-')[0]; else notDefaultLang"
        ></i>
        <ng-template #notDefaultLang>
          <i class="fi fi-{{ activeLocaleFlag }}"></i>
        </ng-template>
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <a
          href
          class="dropdown-item"
          *ngFor="let l of locales"
          (click)="onSelectInputLocale(l); (false)"
          [class.active]="activeLocaleFlag === l.flag"
        >
          <ng-container *ngIf="l.symbol === activeOrg.locale.split('-')[0]; else notDefault">
            <i class="fe fe-flag pl-1"></i>
            {{ 'translatable-input.translations.dropdown.default' | translate }}
          </ng-container>
          <ng-template #notDefault>
            <i class="fi fi-{{ l.flag }}"></i>
            {{ l.name | translate }}
          </ng-template>
        </a>
      </div>
    </div>
  </div>

  <span class="invalid-feedback" *ngIf="sent && hasError('required')">{{
    'validation.required' | translate
  }}</span>
</ng-container>
